import { render, staticRenderFns } from "./EventsParticipants.vue?vue&type=template&id=b1b8bf76&scoped=true&"
import script from "./EventsParticipants.vue?vue&type=script&lang=ts&"
export * from "./EventsParticipants.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b8bf76",
  null
  
)

export default component.exports